<script setup lang="ts">
// Sierra's .card: a flat panel with a bold title (`title`), its body in the default
// slot (muted, at most four lines when `clamp`), a `meta` line, and a `foot` pinned to
// the bottom, so cards in a grid line their actions up.
withDefaults(defineProps<{ title?: string | undefined; clamp?: boolean }>(), { clamp: false });
</script>

<template>
  <section class="itc-card">
    <slot name="head">
      <h2 v-if="title" class="itc-card__title">{{ title }}</h2>
    </slot>
    <div v-if="$slots.default" class="itc-card__body" :class="{ 'itc-card__body--clamp': clamp }"><slot /></div>
    <div v-if="$slots.meta" class="itc-card__meta"><slot name="meta" /></div>
    <div v-if="$slots.foot" class="itc-card__foot"><slot name="foot" /></div>
  </section>
</template>

<style scoped>
.itc-card__title {
  margin: 0;
  font-family: var(--itc-font-body);
  font-size: 16px;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.itc-card__body {
  color: var(--itc-muted);
  font-size: 14px;
  overflow-wrap: anywhere;
}
.itc-card__body--clamp {
  display: -webkit-box;
  overflow: hidden;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.itc-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  color: var(--itc-muted);
  font-size: 13px;
}
.itc-card__foot {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
  padding-top: 4px;
}
</style>
